<template>
  <section class="box">
    <header-com />
    <img class="img" v-for="(item,index) of imgList" :key="index" :src="item.path" @click="toDetail(item,index-1)" />

    <!-- <rightKefuBtn></rightKefuBtn> -->

  </section>
</template>

<script>
import getWXConfig from "@/assets/js/wx.config";
import zhugeObj from "@/assets/js/track";
import wxShare from "@/assets/js/wx.share";
export default {
  name: "homeActiveIndex",
  data() {
    return {
      imgList: [
        {
          path: "/images/home/homeActive_1.jpg",
          id: null,
        },
        {
          path: "/images/home/homeActive_2.jpg",
          id: null,
        },
        {
          path: "/images/home/homeActive_3.jpg",
          id: 102,
        },
        {
          path: "/images/home/homeActive_4.jpg",
          id: 101,
        },
        {
          path: "/images/home/homeActive_5.jpg",
          id: 99,
        },
        {
          path: "/images/home/homeActive_6.jpg",
          id: 100,
        },
        {
          path: "/images/home/homeActive_7.jpg",
          id: 98,
        },
        {
          path: "/images/home/homeActive_8.jpg",
          id: null,
        },
        {
          path: "/images/home/homeActive_9.jpg",
          id: null,
        }
      ],
    };
  },
  computed: {},
  created() {
    zhugeObj.track({
      title: "创意改样—曝光",
      content: {
        '用户来源链接': window.location.href
      }
    });
  },

  mounted() {
    let shareBody = {
        desc: `包大人让你的包包变得充满创意。`,
        title: `邀请你加入 "创意改样" 计划`,
        imgUrl:
          "https://baozheng-front-new.baozheng.cc/2021/05/18/cb6e933b-90b0-40dc-aa55-09541a2e676f.png",
        link: window.location.href
        //  + "&utm_source=ljfx-xqy"
      };
    getWXConfig(null,null,shareBody);
    setTimeout(()=>{
      wxShare(shareBody)
    },1000)
  },

  methods: {
    toDetail(item,index) {
      if (item.id)
        this.$router.push({
          name: "serviceDetail",
          query: { serviceId: item.id },
        });
        zhugeObj.track({
          title: "创意改样—点击商品",
          content: {
            '商品位置': Number(index)
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  .img {
    width: 100%;
    display: block;
  }
}
.kefu-fix {
  width: 500px;
  height: 150px;
  // background-color: #7ADFDF;
  position: fixed;
  right: 0;
  bottom: 200px;
  right: 0 !important;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.asc-line {
  width: 0;
  height: 60px;
  position: relative;
  background: #000000;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  line-height: 60px;
  text-align: center;
  top: -14px;
  border-top-left-radius: 25px;
  border-bottom-right-radius: 25px;
  border-bottom-left-radius: 25px;
}
.kefu-dis {
  animation: myfirst 5s;
  animation-delay: 1s;
}
.kefu-ad {
  animation: mytwo 0.5s;
}
.kefu-baoblack {
  animation: mythree 1s;
}
@keyframes myfirst {
  0% {
    left: 385px;
    width: 0;
  }
  20% {
    left: 0px;
    width: 384px;
  }
  80% {
    left: 0px;
    width: 384px;
  }
  100% {
    left: 385px;
    width: 0;
  }
}
@keyframes mytwo {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}
@keyframes mythree {
  0% {
    margin-top: 48px;
  }
  90% {
    margin-top: 10px;
  }
}
.scrolling {
  right: -63px !important;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
</style>
